import React from 'react';
import styled from 'styled-components';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import { lighten } from 'polished';

interface CustomAlertProps extends AlertProps {
    customBg?: string; // 可选：直接传递背景色
    customColor?: string; // 可选：直接传递文字颜色
}

export const StyledAlert = styled(MuiAlert).attrs<CustomAlertProps>(({ severity, customBg, customColor }) => ({
    severity,
    sx: {
        backgroundColor: customBg, // 优先使用直接传递的颜色
        color: customColor,
    },
}))<CustomAlertProps>`
    /* 基于主题的动态样式 */
    background-color: ${({ theme, severity, customBg }) => customBg || lighten(0.3, theme.c[severity || 'info'])} !important;
    color: ${({ theme, severity, customColor }) => customColor || theme.c[severity || 'info']};

    /* 图标样式 */
    .MuiAlert-icon {
        color: inherit; // 继承文字颜色
    }
`;
